import {
  PromoteMemberDocument,
  PromoteMemberMutation,
  PromoteMemberMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const usePromoteMember = () => {
  const [mutation, { loading }] = useMutation(PromoteMemberDocument, {
    extractorFn: (data: PromoteMemberMutation) => data.teamsMutations.updateTeamsMembership,
  })

  const promoteMember = (variables: PromoteMemberMutationVariables) => {
    return mutation({
      variables,
      update(cache, { data }) {
        const promotedMembershipId = data?.teamsMutations.updateTeamsMembership.membership?.id

        if (!promotedMembershipId) return

        cache.modify({
          id: cache.identify({ __typename: 'TeamsMembership', id: promotedMembershipId }),
          fields: {
            lead() {
              return true
            },
          },
        })
      },
    })
  }

  return { loading, promoteMember }
}

export default usePromoteMember
